export default __webpack_public_path__ + "static/media/fad-logo-audacity.650944d6.svg";